import { defineStyle, defineStyleConfig } from "@chakra-ui/react";

const variants = {
  lede: defineStyle({
    fontSize: "lede",
    lineHeight: "lede",
    color: "warm.600",
    maxW: "46ch",
    textWrap: "pretty",
  }),
  eyebrow: defineStyle({
    fontSize: "eyebrow",
    fontWeight: "normal",
    letterSpacing: "eyebrow",
    textTransform: "uppercase",
    color: "warm.600",
  }),
  eyebrowBrand: defineStyle({
    fontSize: "eyebrow",
    fontWeight: "normal",
    letterSpacing: "eyebrow",
    textTransform: "uppercase",
    color: "brand.600",
  }),
  body: defineStyle({
    fontSize: "body",
    lineHeight: "prose",
    color: "warm.600",
    textWrap: "pretty",
  }),
  small: defineStyle({
    fontSize: "small",
    color: "warm.600",
  }),
};

export const Text = defineStyleConfig({ variants });
